const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-v2-hazard-box'] = {
        c: () => require('partner/modules/moe-v2-hazard-box/moe-v2-hazard-box.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-v2-hazard-box',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-v2-hazard-box'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-v2-hazard-box|moe-v2-hazard-box'] = {
                c: () => require('partner/modules/moe-v2-hazard-box/moe-v2-hazard-box.view.tsx'),
                cn: '__local__-__local__-moe-v2-hazard-box'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };